export enum EvaluationStatus {
  NOT_STARTED = 0,
  EVALUATING = 10,
  EVALUATED = 20,
}
